var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiGlyphAdjustmentHorizon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.845 10.34C.659 11.531 1.659 12.75.09 14.555c-.71.816 2.921.568 4.718-1.238a1.86 1.86 0 00-.271-2.7 1.842 1.842 0 00-2.693-.27zM14.952.04c-.606-.6-7.327 4.9-9.327 6.906a13.99 13.99 0 00-1.628 1.931c-.133.175.043.227.12.268a3.765 3.765 0 011.024.753 3.7 3.7 0 01.749 1.028c.042.078.095.254.267.121A14.05 14.05 0 008.08 9.412c2-2.008 7.48-8.756 6.872-9.365z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiGlyphAdjustmentHorizon);
export default __webpack_public_path__ + "static/media/si-glyph-adjustment-horizon.1ec8741c.svg";
export { ForwardRef as ReactComponent };